<ng-container *isAllowed="[ERoleAdminString.Admin, 'queue.create']">
  <hr class="mb-10" />
  <div class="flex items-center justify-center m-4">
    <button type="button" class="w-80 btn btn--secondary mr-5" (click)="formAberto = true">Cadastrar Novo</button>
  </div>

  <app-dialog
    *ngIf="formAberto"
    heading="CADASTRAR NOVA FILA"
    description="Insira os dados abaixo para cadastrar"
    (closed)="formAberto = false"
  >
    <form class="mt-5 wrapper" [formGroup]="formFila" (ngSubmit)="salvarFila()">
      <input type="text" class="form-input" placeholder="Nome da Fila" formControlName="name" />
      <input type="description" class="form-input" placeholder="Descrição" formControlName="description" />
      <input
        type="email"
        class="form-input"
        placeholder="E-mail de suporte online"
        formControlName="onlineSupportEmail"
      />
      <input
        type="email"
        class="form-input"
        placeholder="E-mail de suporte offline"
        formControlName="offlineSupportEmail"
      />

      <ng-select
        *ngIf="podeEscolherEmpresa"
        notFoundText="Nenhum item encontrado"
        [items]="opcoesCompany"
        [searchable]="true"
        placeholder="Empresa"
        formControlName="companyId"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
      >
      </ng-select>

      <div class="flex items-center text-sm font-medium text-chathams-blue">
        <input
          type="checkbox"
          id="newQueueShowPatientData"
          class="mr-3 form-input form-checkbox on-white check-pink"
          formControlName="showPatientData"
        />
        <label for="newQueueShowPatientData">Exibir dados do paciente (sinais vitais e triagem) no atendimento</label>
      </div>

      <button *isAllowed="[ERoleAdminString.Admin, 'queue.create']" type="submit" class="h-9 btn btn--secondary">
        Cadastrar Novo
      </button>
    </form>
  </app-dialog>
</ng-container>
